import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PaymentService } from '@app/services/payment.service';
import { ActiveTabDisplayComponent } from '@app/chat/tab-navigation/tab-navigation-mobile/active-tab-display.component';
import { TabNavigationMobileComponent } from '@app/chat/tab-navigation/tab-navigation-mobile/tab-navigation-mobile.component';
import { TabNavigationComponent } from '@app/chat/tab-navigation/tab-navigation.component';
import { UserMenuMobileComponent } from '@app/profile/user-menu-mobile/user-menu-mobile.component';
import { UserMenuTriggerComponent } from '@app/profile/user-menu/user-menu-trigger.component';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    RouterLink,
    TabNavigationComponent,
    TabNavigationMobileComponent,
    UserMenuTriggerComponent,
    UserMenuMobileComponent,
    ActiveTabDisplayComponent,
  ],
  styles: `
    :host {
      @apply flex w-full items-center justify-between bg-black pt-3;
    }
  `,
  template: `
    <!-- Qira logo -->
    <a routerLink="chat" class="block pl-5 pr-8 text-white max-lg:hidden" data-testid="header-logo">
      <span class="icon-qira-logo text-3xl"></span>
    </a>

    <!-- Mobile tab navi -->
    @if (!subscriptionExpired()) {
      <app-tab-navigation-mobile class="mx-3 lg:hidden" />
    } @else {
      <a routerLink="chat" class="block pl-6 pr-8 text-white lg:hidden">
        <span class="icon-qira-logo text-3xl"></span>
      </a>
    }

    <!-- Tab Navi -->
    @if (!subscriptionExpired()) {
      <app-active-tab class="flex-1 overflow-hidden lg:hidden" />
      <div class="hidden flex-1 items-center justify-start lg:flex">
        <app-tab-navigation class="flex-1" />
      </div>
    }

    <!-- User menu -->
    <app-user-menu-trigger class="mx-3 mb-1 max-lg:hidden" />
    <app-user-menu-mobile class="mb-1 lg:hidden" />
  `,
})
export class HeaderComponent {
  paymentService = inject(PaymentService);

  subscriptionExpired = computed(() => this.paymentService.subscriptionExpired());
}
